const moment = require('moment');
const {
    tableSettings,
    tableRemoveLoader,
    tablePaginationCheck,
    tableMarkUpHelper
} = require("./jquery-data-table");
const Swal = require('sweetalert2');
const {singleValueDateRangePicker} = require("./date-range-picker");


module.exports = {
    getSpinner() {
        return `<div class="custom-spinner text-center mb-4 mt-4">
                    <span class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </span>
                </div>`
    },

    trans(key) {
        if (window.hasOwnProperty('translations') && window.translations.hasOwnProperty(key)) {
            return window.translations[key];
        }
        return key;
    },

    setDropdownInputSearchIcon($dropdown) {
        if ($dropdown.length) {
            // const getDropdown = ;
            const getParent = $dropdown.siblings('.dropdown-menu.show').closest('.dropdown')
            if (!getParent.hasClass('inserted-search-icon')) {
                const getSearchBox = getParent.find('.bs-searchbox')
                getParent.addClass('inserted-search-icon')
                if (getSearchBox.length) {
                    getSearchBox.prepend('<span class="search-icon icon-search"></span>')
                }
            }
        }
    },

    setDropdownHeader($dropdown) {
        if ($dropdown.prop('tagName') !== 'SELECT') {
            return;
        }
        const getDropdown = $dropdown.siblings('.dropdown-menu');
        if ($dropdown.find('option').length) {
            if ($dropdown.attr('options') && $dropdown.attr('options') === 'not-clear') {
                //don't show clear or all header
            } else if (getDropdown.find('.popover-header').length === 0) {
                getDropdown.prepend(`<div class="popover-header">
                    <div class="select-header-options">
                        <span class="select-all float-right text-uppercase pointer">${window.helpers.trans('dropdown_check_all')}</span>
                        <span class="deselect-all float-right text-uppercase pointer">${window.helpers.trans('dropdown_clear_all')}</span>
                        </div>
                    </div>
                `)
            }

            getDropdown.find('.select-all').click(function () {
                $dropdown.selectpicker('selectAll');

                // setTimeout(function () {
                //     $dropdown.selectpicker('toggle');
                // }, 10) // nu vrea altfel
            })

            getDropdown.find('.deselect-all').click(function () {
                $dropdown.selectpicker('deselectAll');

                // setTimeout(function () {
                //     $dropdown.selectpicker('toggle');
                // }, 10) // nu vrea altfel
            })
        }
    },

    setCookie(name, value, daysToLive) {
        var cookie = name + "=" + encodeURIComponent(value);
        // var domainName = window.location.hostname.replace(/^[^.]+\./g, "");
        var parts = window.location.hostname.split('.');
        var domainName = parts.slice(-2).join('.');

        if (!domainName === 'localhost') {
            domainName = "." + domainName;
        }

        if (typeof daysToLive === "number") {
            cookie += "; max-age=" + (daysToLive * 24 * 60 * 60) + "; domain=" + domainName;
            document.cookie = cookie;
        }
    },

    getCookie(name) {
        var cookieArr = document.cookie.split(";");
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if (name == cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    },

    removeCookie(name) {
        var domainName = window.location.hostname.replace(/^[^.]+\./g, "");

        if (!domainName === 'localhost') {
            domainName = "." + domainName;
        }

        var cookie = name + "=; max-age=0; domain=" + domainName;
        document.cookie = cookie;
    },

    buildSearchUrl(url, $form, defaultFilters) {
        let params = new URLSearchParams(window.helpers.formValuesToObject($form, defaultFilters));
        return url + '?' + params;
    },

    formValuesToObject($form, defaultFilters) {
        const filters = $.extend({}, defaultFilters)
        if ($form) {
            let formData = $form.serializeArray();
            for (let filter of formData) {
                if (filters.hasOwnProperty(filter.name) && typeof filters[filter.name] == 'string') {
                    filters[filter.name] = [filters[filter.name]]
                }
                if (filters.hasOwnProperty(filter.name) && typeof filters[filter.name] == 'object') {
                    filters[filter.name].push(filter.value);
                } else {
                    filters[filter.name] = filter.value;
                }
            }
        }

        return filters;
    },

    getRevenueModelBadge(revenueModel) {
        if (revenueModel == 1) {
            return `<div class="d-inline-block table-skeleton-item my-1"><span class="badge fw-500 badge-rounded badge-sm badge-type-warning">CPA</span></div>`;
        } else if (revenueModel == 2) {
            return `<div class="d-inline-block table-skeleton-item my-1"><span class="badge fw-500 badge-rounded badge-sm badge-type-success">RS</span></div>`;
        } else if (revenueModel == 4) {
            return `<div class="d-inline-block table-skeleton-item my-1"><span class="badge fw-500 badge-rounded badge-sm badge-type-info">Hybrid</span></div>`;
        }

        return '';
    },

    initDropdownSelect() {
        $('.bb-dropdown-select').selectpicker({
            styleBase: 'form-control',
            showTick: true,
            // title: window.helpers.trans('all'),
            noneSelectedText: window.helpers.trans('all'),
            // header: showHeader ? '<span class="font-weight-bold">--</span>' : '',
            selectedTextFormat: 'count > 1',
            multiple: true,
            liveSearch: true,
            liveSearchPlaceholder: window.helpers.trans('search-input-placeholder'),
            countSelectedText: function (selectedCnt, totalCnt, c) {
                // this.selectpicker('refresh');
                if (selectedCnt === totalCnt) {
                    return window.helpers.trans('all')
                }
                return selectedCnt + ' selected ';
            },
        })
            .on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                if ($(this).data('dropdown-header')) {
                    window.helpers.setDropdownHeader($(this))
                }
                window.helpers.setDropdownInputSearchIcon($(this))
            })
            .on('show.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                if ($(this).data('dropdown-header')) {
                    window.helpers.setDropdownHeader($(this))
                }
                window.helpers.setDropdownInputSearchIcon($(this))
            })

        $('.form-item.form-item-loader').removeClass('form-item-loader');
    },

    resetFormValues(formId, resetToAll = true) {
        $(`${formId} .bb-dropdown-select`).each(function (index, item) {
            $(item).selectpicker('val', resetToAll ? null : 0);
        })

        $(`${formId} input`).each(function (index, item) {
            $(item).val('');
        })
    },

    synchronizeFormValues({isDesktop, modalFormId, desktopFormId, resetToAll = true,}) {
        const formFiltersValue = window.helpers.formValuesToObject(isDesktop
            ? $(desktopFormId)
            : $(modalFormId)
        );

        if (isDesktop) {
            $(`${modalFormId} .bb-dropdown-select`).each(function (index, item) {
                if (formFiltersValue.hasOwnProperty(item.name)) {
                    $(item).selectpicker('val', formFiltersValue[item.name]);
                } else {
                    // $(item).selectpicker('deselectAll')
                    $(item).selectpicker('val', resetToAll ? '' : 0)
                }
            })

            $(`${modalFormId} input`).each(function (index, item) {
                if (formFiltersValue.hasOwnProperty(item.name)) {
                    $(item).val(formFiltersValue[item.name]);
                } else if ($(item).attr('readonly') === undefined) {
                    $(item).val('')
                }
            })
        } else {
            $(`${desktopFormId} .bb-dropdown-select`).each(function (index, item) {
                if (formFiltersValue.hasOwnProperty(item.name)) {
                    $(item).selectpicker('val', formFiltersValue[item.name]);
                } else {
                    // $(item).selectpicker('deselectAll')
                    $(item).selectpicker('val', resetToAll ? '' : 0)
                }
            })

            $(`${desktopFormId} input`).each(function (index, item) {
                if (formFiltersValue.hasOwnProperty(item.name)) {
                    $(item).val(formFiltersValue[item.name]);
                } else if ($(item).attr('readonly') === undefined) {
                    $(item).val('')
                }
            })
        }
    },

    initJqueryDataTable(elementId, additionalArgs) {
        let parsedExtraProps = {}
        if (typeof additionalArgs === 'object' && additionalArgs !== null) {
            parsedExtraProps = additionalArgs
        }
        $(`${elementId}`).DataTable({
            order: [[0, 'desc']],
            pageLength: 10,
            processing: true,
            ...tableSettings,
            ...parsedExtraProps,

            initComplete: function () {
                tableRemoveLoader({_this: this, serverSide: false});
                // $('.table-skeleton').closest().remove();
            },
            drawCallback: function () {
                window.helpers.initTooltip()
                tablePaginationCheck(this);
                window.helpers.removeInputPreloader();
            }
        });
        tableMarkUpHelper()
    },

    onFocusInputHandler() {
        $(".input-group > input")
            .focus(function (e) {
                $(this).parent().addClass("input-group-focus");
            })
            .blur(function (e) {
                $(this).parent().removeClass("input-group-focus");
            });

        $(".input-group.input-group-left > input")
            .focus(function (e) {
                $(this).parent().addClass("input-group-focus");
            })
            .blur(function (e) {
                $(this).parent().removeClass("input-group-focus");
            });
    },

    hideTableColumnsHandler({table = null, dropdownBtn = null, resetOnClick = false}) {
        if (table) {
            $(dropdownBtn).removeAttr('disabled')
            const itemsList = $('.hide-column');
            const checkAllBtnId = 'check-all-columns'
            const uncheckAllBtnId = 'uncheck-all-columns'
            const getDropdown = $(dropdownBtn).next('.dropdown-menu')

            if (resetOnClick) {
                itemsList
                    .off('click')
                    .removeClass('active')
            }

            if (getDropdown && getDropdown.find(`#${checkAllBtnId}`).length <= 0) {
                $(getDropdown).prepend(`
                    <div class="popover-header">
                        <div class="select-header-options">
                            <span id="${checkAllBtnId}" class="select-all text-uppercase pointer">
                                ${window.helpers.trans('dropdown_check_all')}
                            </span>
                            <span id="${uncheckAllBtnId}" class="deselect-all text-uppercase pointer">
                                ${window.helpers.trans('dropdown_clear_all')}
                            </span>
                        </div>
                    </div>
                `)
            }

            getDropdown.find(`#${checkAllBtnId}`).on('click', function (e) {
                e.stopPropagation();
                itemsList.each(function (index, item) {
                    $(item).removeClass('active');
                    let columnIdx = $(item).attr('data-column');
                    let column = table.column(columnIdx);
                    if (!column.visible()) {
                        column.visible(!column.visible());
                    }
                });
            })

            getDropdown.find(`#${uncheckAllBtnId}`).on('click', function (e) {
                e.stopPropagation();
                itemsList.each(function (index, item) {
                    $(item).addClass('active');
                    let columnIdx = $(item).attr('data-column');
                    let column = table.column(columnIdx);
                    if (column.visible()) {
                        column.visible(!column.visible());
                    }
                });
            })

            itemsList.each(function (index, item) {
                $(item).on('click', function (e) {
                    e.stopPropagation();
                    $(item).toggleClass('active');
                    let columnIdx = e.target.getAttribute('data-column');
                    let column = table.column(columnIdx);
                    column.visible(!column.visible());
                });
            });
        } else if (dropdownBtn) {
            $(dropdownBtn).attr('disabled', true)
        }
    },

    buttonLoader({status, button, buttonText}) {
        const buttonElement = typeof button === "string" ? $(button) : button
        if (buttonElement && status === 'default' && buttonText) {
            buttonElement
                .removeClass('loading')
                .removeClass('checked')
                .html(buttonText)
        } else if (buttonElement && status === 'checked') {
            buttonElement.addClass('checked')
            buttonElement.html('<i class="fs-16 icon-check"></i>');
        } else if (buttonElement && status === 'loading') {
            buttonElement
                .addClass('loading')
                .html('<span class="btn-loader"></span>')
        } else {
            return '';
        }
    },

    removeInputValidationError() {
        $(':input').on('input', function (e) {
            if ($(e.target).hasClass('is-invalid')) {
                $(e.target).removeClass('is-invalid')
            }
        })
    },

    toggleInputPasswordVisibility(buttonId) {
        $(buttonId).on('click', function (e) {
            const input = $(this).parents('.input-group').first().find('.form-control')
            if ($(input).prop('type') === 'text') {
                $(input).attr('type', 'password');
                $(buttonId).find('.icon-see').removeClass('icon-see').addClass('icon-hide')
            } else {
                $(input).attr('type', 'text');
                $(buttonId).find('.icon-hide').removeClass('icon-hide').addClass('icon-see')
            }
        })
    },

    toggleShowHideIcon() {
        if ($('.icon-hide').length) {
            const getShowHideBtn = $('.icon-hide').parents('.input-group').find('.input-group-append button')
            if (getShowHideBtn.length) {
                $(getShowHideBtn).addClass('invisible')
            }
        }

        $('input').on('input', function (e) {
            const getShowHideBtn = $(this).parents('.input-group').find('.input-group-append button')
            if (e.target.value === '') {
                getShowHideBtn.addClass('invisible')
                getShowHideBtn.removeClass('visible')
            } else {
                getShowHideBtn.removeClass('invisible')
                getShowHideBtn.addClass('visible')
            }
        })
    },

    tableSkeleton(isSmall, hideHeader) {
        return `<div class="d-flex flex-column table-preloader">
            <div class="table-preloader-row table-preloader-row-header ${hideHeader ? 'd-none' : ''}">
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
            </div>
            <div class="table-preloader-row">
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
            </div>
            <div class="table-preloader-row">
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
            </div>
            <div class="table-preloader-row ${isSmall ? 'd-none' : ''}">
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
            </div>
            <div class="table-preloader-row ${isSmall ? 'd-none' : ''}">
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
            </div>
            <div class="table-preloader-row ${isSmall ? 'd-none' : ''}">
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
                <div class="table-preloader-item"></div>
            </div>
        </div>`
    },

    toastMessage({message, statusClass, title, duration}) {
        let iconClass;

        if (statusClass === 'danger') {
            iconClass = 'decline'
        } else if (statusClass === 'warning' || statusClass === 'info') {
            iconClass = 'alert-on';
        } else if (
            statusClass === 'primary' ||
            statusClass === 'secondary' ||
            statusClass === 'success' ||
            statusClass === 'light' ||
            statusClass === 'dark'
        ) {
            iconClass = 'check';
        }
        if (message) {
            const Toast = Swal.mixin({
                // showClass: {
                // backdrop: '', // disable backdrop animation
                // popup: '', // disable popup animation
                // icon: ''  // disable icon animation
                // },
                icon: '',
                toast: true,
                position: "top-end",
                showClass: {
                    popup: 'fade-in-right',
                },
                hideClass: {
                    popup: 'fade-out-right',
                },
                showConfirmButton: false,
                timer: duration ? duration : 5000,
                timerProgressBar: true,
                customClass: {
                    container: 'toast-message',
                },
                onOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                title: '',
                icon: '',
                html: `<div class="toast-message__wrapp">
                            <div class="toast-message__data">
                                ${title ? '<h6 class="toast-message__title">' + title + '</h6>' : ''}
                                <p class="toast-message__text">${message}</p>
                            </div>
                            <span class="toast-message__icon"><i class="icon-decline"></i></span>
                        </div>`,
            });
        }
    },

    swal2Template() {
        return ({
            title: window.helpers.trans('btn_pm_delete'),
            showCancelButton: true,
            cancelButtonText: window.helpers.trans('Cancel'),
            confirmButtonText: window.helpers.trans('Confirm'),
            showCloseButton: true,
            closeButtonHtml: '<span class="btn btn-close btn-close-icon"></span>',
            icon: 'warning',
            focusConfirm: false,
            focusCancel: false,
            html: `<p>${window.helpers.trans('Are you sure you want to delete this payment method ?')}</p>`,
            reverseButtons: true,
            iconHtml: `<span class="modal-icon-wrapper"><i class="icon-alert-on"></i></span>`,
            customClass: {
                container: 'modal sm',
                popup: 'modal-content p-0',
                header: 'modal-header',
                title: 'modal-title-left',
                content: 'modal-body',
                // closeButton: '',
                // icon: '',
                // image: '',
                // htmlContainer: '',
                // input: '',
                // inputLabel: '',
                // validationMessage: '',
                actions: 'm-0 pt-0 px-3 pb-3  no-wrap',
                confirmButton: 'btn btn-md btn-main',
                // denyButton: '',
                cancelButton: 'btn btn-md btn-outline-main no-border',
                loader: '',
                // footer: '',
                // timerProgressBar: '',
            }
        })
    },

    validateFormInputs({
                           formId,
                           checkIsFormDataUpdated = false,
                           checkBoxId = null,
                           ignoredInputNames = []
                       }) {
        const getForm = $(formId);
        const getSubmitBtn = getForm.find("button[type='submit']");
        const getFormData = getForm.serializeArray()
        const skipValidationFor = ['comments', '_token', 'fakenameremembered', 'fakepasswordremembered', ...ignoredInputNames]

        for (const item in getFormData) {
            if (skipValidationFor.indexOf(getFormData[item].name) !== -1) {
                continue
            } else if (getFormData[item].value.trim() === '' || checkIsFormDataUpdated) {
                getSubmitBtn.attr('disabled', true)
                break
            }
        }

        getForm.on('input textInput change', function (e) {
            const getUpdatedFormData = $(formId).serializeArray()
            const isOldFormData = checkIsFormDataUpdated
                ? getUpdatedFormData.every((item, index) => item.value === getFormData[index].value)
                : false
            if (checkBoxId && checkBoxId.length && $(checkBoxId)[0].checked) {
                getSubmitBtn.removeAttr('disabled')
            } else if (checkBoxId) {
                return getSubmitBtn.attr('disabled', true)
            }

            if (isOldFormData) {
                return getSubmitBtn.attr('disabled', true)
            }

            for (const item in getUpdatedFormData) {
                if (skipValidationFor.indexOf(getUpdatedFormData[item].name) !== -1) {
                    continue
                } else if (getUpdatedFormData[item].value.trim() === '') {
                    getSubmitBtn.attr('disabled', true)
                    break
                }
                getSubmitBtn.removeAttr('disabled')
            }
        })
    },

    initTooltip() {
        // enable tooltip when sort, filter or using pagination
        $('[data-toggle="tooltip"]').tooltip()
    },

    backArrowHandler(btnId) {
        const getBackBtn = document.querySelector(btnId);
        let redirect = false;

        if (getBackBtn) {
            redirect = getBackBtn.getAttribute('href');
        }

        if (redirect) {
            getBackBtn.addEventListener('click', function (e) {
                e.preventDefault()
                history.back();
            })
        }
    },

    dateFormatter(date, type = 1) {
        if (type === 1 && date) {
            return moment(date).format('DD.MM.YYYY')
        }

        if (type === 2 && date) {
            return moment(date).format('MMM-YYYY')
        }

        if (type === 3 && date) {
            return moment(date).format('DD-MM-YYYY hh:mm:ss')
        }

        return '--';
    },

    getTimestamp(date) {
        const createDate = new Date(date);
        if (createDate?.getTime) {
            return createDate.getTime();
        }
        return 'wrong date format';
    },

    adminGuaranteedPlanModal() {
        window.helpers.initDropdownSelect();
        singleValueDateRangePicker({
            calendarId: '#start_date',
            hiddenInputId: "#hidden_start_date"
        });
        singleValueDateRangePicker({
            calendarId: '#end_date',
            hiddenInputId: '#hidden_end_date'
        });
        window.helpers.onFocusInputHandler();
    },

    removeInputPreloader() {
        $('.form-item.form-item-loader').removeClass('form-item-loader');
    },

    getDeviceType(device) {
        if (device > 2) {
            return 'N/A';
        }
        return device === 1 ? 'Mobile' : 'Desktop'
    },

    getPlayerFTDStatus(status) {
        if (status === 0) {
            return 'Pending'
        }
        if (status === 1) {
            return 'Qualified'
        }
        if (status === 2) {
            return 'Non-qualified'
        }

        return '--'
    },

    getRevenueDescription(id) {
        if (id === 1) {
            return 'cpa'
        }
        if (id === 2) {
            return 'revenue'
        }
        if (id === 3) {
            return 'subaff'
        }
        if (id === 4) {
            return 'hybrid'
        }
        return 'N/A';
    },

    getBaseCurrency() {
        return '$';
    },

    formatAmount(
        {
            amount,
            parseAmount = false,
            currency = window.helpers.getBaseCurrency(),
            isNotApplicable = false
        }
    ) {
        if (Boolean(isNotApplicable)) {
            return 'N/A';
        } else if (!amount || Number(amount) === 0) {
            return currency + ' 0.00';
        } else if (parseAmount) {
            const processedAmount = !isNaN(amount) ? Number(amount) : amount
            return currency + ' ' + processedAmount.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            });
        } else {
            return currency + ' ' + amount;
        }
    },
    removeCommasFromAmount(val) {
        if (typeof val !== "string") {
            return Number(String(val).replace(/[, ]+/g, ''))
        }
        return Number(val.replace(/[, ]+/g, ''))
    }
};
